const CDN_URL = import.meta.env.VITE_CDN_URL ?? ''

export const cdn = (path: string): string => `${CDN_URL}${path.startsWith('/') ? path : `/${path}`}`
